/** Landlord ids stored on a property (legacy landlordId and landlordIds). */
export function propertyLandlordIds(property) {
  const ids = [];
  if (Array.isArray(property?.landlordIds)) ids.push(...property.landlordIds);
  if (property?.landlordId) ids.push(property.landlordId);
  return [...new Set(ids.filter(Boolean))];
}

/**
 * Property is disabled, or one of its landlords is.
 * Records stay visible. Certificate alerts and renewal reminders stay off.
 */
export function isAlertsOnHold(property, disabledLandlordIds) {
  if (!property) return false;
  if (property.disabled === true || property.landlordDisabled === true) return true;
  if (!disabledLandlordIds) return false;
  const held = disabledLandlordIds instanceof Set ? disabledLandlordIds : new Set(disabledLandlordIds);
  return propertyLandlordIds(property).some((id) => held.has(id));
}

/** Status change that goes with the property Disable control. Enable restores the previous status. */
export function propertyDisablePatch(property, disabled) {
  if (disabled) {
    const patch = { disabled: true, status: 'unavailable' };
    if (property?.status && property.status !== 'unavailable') patch.statusBeforeDisable = property.status;
    return patch;
  }
  const patch = { disabled: false };
  if (property?.statusBeforeDisable) patch.status = property.statusBeforeDisable;
  return patch;
}
